import { loadStripe } from '@stripe/stripe-js';

// Singleton per modus — loadStripe kalles kun én gang per (test/live)
const stripePromises = { test: null, live: null };

const isValidStripeKeyFormat = key => /^pk_(test|live)_[A-Za-z0-9]{20,}$/.test(key ?? '');

export function getStripe(isTestAccount) {
  const mode = isTestAccount ? 'test' : 'live';
  const key = isTestAccount
    ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST
    : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_LIVE;

  if (!isValidStripeKeyFormat(key)) {
    const envFile = isTestAccount ? '.env.local' : '.env.production';
    console.warn(`Stripe publishable key (${mode}) er ikke konfigurert — sjekk ${envFile}`);
    return null;
  }
  if (!stripePromises[mode]) {
    stripePromises[mode] = loadStripe(key);
  }
  return stripePromises[mode];
}
